"use client";

import React from "react";
import { Heart, MapPin, Hospital } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "מטפלים ישראלים בלבד",
  description: "צוות סיעודי מקצועי הכולל מטפלים מוסמכים בטיפול רפואי, אמין ומסור, דובר עברית, המעניק יחס אישי וחם תוך הבנת התרבות והמנטליות המקומית, כולל בבתי חולים כגון שיבא, איכילוב, בילינסון, אסותא, סורוקה.",
  icon: Heart
}, {
  title: "פריסה ארצית מלאה",
  description: "שירות זמין בכל רחבי הארץ ובכל בתי החולים בישראל, עם התחייבות להגעה מהירה של עד 5 שעות לכל מקום שבו תצטרכו אותנו, כולל שיבא, איכילוב, בילינסון, אסותא, סורוקה.",
  icon: MapPin
}, {
  title: "שירות לבית ולבית חולים",
  description: "ליווי והשגחה צמודה ומקצועית, בין אם בסביבה הביתית המוכרת ובין אם במהלך אשפוז במוסד רפואי, כולל בתי חולים מובילים כגון שיבא, איכילוב, בילינסון, אסותא, סורוקה.",
  icon: Hospital
}];
export default function OurSecurityGuarantee() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="הביטחון-שלכם-בידיים-שלנו" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
        <div ref={headerRef} className={`text-center max-w-3xl mx-auto mb-12 md:mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl font-default font-bold text-foreground mb-4">
            הביטחון שלכם בידיים שלנו
          </h2>
          <p className="text-lg text-muted-foreground font-default">
            אנו מתחייבים לספק את השירות המקצועי, המהיר והאמין ביותר, כדי שאתם
            והיקרים לכם תוכלו להיות בראש שקט.
          </p>
        </div>

        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 transition-all duration-1000 ease-out delay-200 ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {features.map((feature, i) => <div data-index={i} key={i} className="h-full">
              <Card className="h-full group hover:shadow-xl transition-all duration-300 border-border/50 bg-card text-center">
                <CardHeader className="pb-4 flex flex-col items-center">
                  <div className="w-16 h-16 rounded-2xl bg-accent/30 flex items-center justify-center mb-4 transition-colors duration-300">
                    <feature.icon className="w-8 h-8 text-primary group-hover:text-[var(--chart-2)] transition-colors duration-300" />
                  </div>
                  <CardTitle className="text-xl font-default font-bold text-foreground">
                    {feature.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base text-muted-foreground font-default leading-relaxed">
                    {feature.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}